import { render, staticRenderFns } from "./ProductosRegistraReporte.vue?vue&type=template&id=3c1fedf8&"
import script from "./ProductosRegistraReporte.vue?vue&type=script&lang=js&"
export * from "./ProductosRegistraReporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports